import { render, staticRenderFns } from "./test-speakers.vue?vue&type=template&id=1daf3f80&"
import script from "./test-speakers.vue?vue&type=script&lang=js&"
export * from "./test-speakers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports